<template>
  <div class="children-view">
    <index-edit-show @setMould="setMould" v-if="mouldId!=8&&mouldId" :companyId="companyId" :createdTime="companyCreatedTime" ref='index' ></index-edit-show>
    <new-mould v-if="mouldId==8" :data="data[0]"></new-mould>
  </div>

</template>

<script>
  import indexEditShow from './indexEditShow.vue'
  import newMould from '../IndexEdit/mould/newMould.vue'
  export default{
    data(){
      return{
        mouldId:null,
        companyId:null,
        companyCreatedTime:null,
        data:[],
      }
    },
    created() {
      console.log(this.$store.state)
      this.companyId = Number(sessionStorage.getItem('companyId')||localStorage.getItem('companyId'));
      this.companyCreatedTime = this.$store.state.companyCreatedTime;
      this.getId()
    },
    activated() {
      if(this.mouldId==8){
        this.$store.state.HTMLminWidth = 1902
      }
      if(this.$route.meta.updataMark) {
         this.getId()
         this.$route.meta.updataMark = false
      }
      let self = this;
      // var afterUrl = window.location.href.split('?')[1];
      // if(afterUrl) {
      // 	/*如果是预览进入 则隐藏头部*/
      // 	this.$parent.ChangeHeaderShow('hide');
      // 	this.typePreview = true;
      // } else {
      // 	//设置头部
      // 	this.$store.state.headerActive = 0;
      // 	this.typePreview = false;
      // }
    },
    methods:{
      ChangeHeaderShow(){
        this.$parent.ChangeHeaderShow('hide');
      },
      setMould(id){
        if(id==8){
          this.getId()
        }
      },
      getId(){
        this.get('/CompanyScreen/get', {companyId: this.companyId}).then((res) => {
          if(res.success){
            this.data = res.result.items
            this.mouldId = res.result.layout
            if(this.mouldId==8){
              this.$store.state.HTMLminWidth = 1902
            }
          }
        })
      }
    },
    components:{indexEditShow,newMould}
  }
</script>

<style scoped="">
  .children-view{
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexEditShow/indexEditShowBox.vue